import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import withStyles from "@material-ui/core/styles/withStyles";
import { variables } from "../styles";

const snackbarStyles = {
  error: {
    backgroundColor: `${variables.RED_CARDINAL} !important`,
  },

  message: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
  },

  errorIcon: {
    marginRight: '24px',
  },
};

const ErrorSnackbar = props => (
  <Snackbar
    open={props.open}
    autoHideDuration={1000000}
    onClose={props.onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
  >
    <SnackbarContent
      className={props.classes.error}
      message={
        <span id="error-snackbar" className={props.classes.message}>
          <ErrorIcon className={props.classes.errorIcon} />
          {props.message}
        </span>
      }
    />
  </Snackbar>
);

export default withStyles(snackbarStyles)(ErrorSnackbar);



// WEBPACK FOOTER //
// ./src/componentes/ErrorSnackbar.js